import { render, staticRenderFns } from "./InPatientCare.vue?vue&type=template&id=fe11b7cc&scoped=true"
import script from "./InPatientCare.vue?vue&type=script&lang=js"
export * from "./InPatientCare.vue?vue&type=script&lang=js"
import style0 from "./InPatientCare.vue?vue&type=style&index=0&id=fe11b7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe11b7cc",
  null
  
)

export default component.exports